import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import './UserAuth.css';

const API_BASE = process.env.REACT_APP_API_URL || 'https://saskararecord.com/api';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await axios.post(`${API_BASE}/users-auth/forgot-password`, { email });
      setSent(true);
    } catch (err) {
      setError(err.response?.data?.error || 'Gagal memproses, coba lagi.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="user-auth-page">
      <div className="user-auth-box">
        <Link to="/" className="user-auth-logo">
          <img src="/logo.png" alt="Saskara Record" className="user-auth-logo-img" />
          SASKARA<span>RECORD</span>
        </Link>
        <p className="user-auth-subtitle">Lupa Password</p>

        {sent ? (
          <div style={{ textAlign: 'center', color: '#9A9AA2', fontSize: 14 }}>
            <p>Kalau email kamu terdaftar, link reset password sudah dikirim. Cek inbox (atau folder spam) email kamu.</p>
          </div>
        ) : (
          <>
            {error && <div className="user-auth-error">{error}</div>}
            <form onSubmit={handleSubmit}>
              <input
                type="email"
                placeholder="Email terdaftar"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
              <button type="submit" disabled={loading}>
                {loading ? 'Mengirim...' : 'Kirim Link Reset'}
              </button>
            </form>
          </>
        )}

        <p className="user-auth-footer">
          <Link to="/login">← Kembali ke Login</Link>
        </p>
      </div>
    </div>
  );
}
